export default __webpack_public_path__ + "static/media/boy-1.ff13f036.png";